import { PageLoader } from './PageLoader'
export { usePageLoader } from './usePageLoader'
export default PageLoader
